import { CobaltBannerKind } from '@cae/cobalt-angular/components/banner';

export class Message {
  public message: string;
  public kind: CobaltBannerKind;
  public isVisible: boolean;
  public name?: string = '';
  public hideSuffix?: boolean = false;
  public hideContactUs?: boolean = false;

  constructor(clone: Message = null) {
    this.message = '';
    this.kind = 'success';
    this.isVisible = false;

    if (clone) {
      this.message = clone.message;
      this.kind = clone.kind;
      this.isVisible = clone.isVisible;
    }
  }

  public static create(
    message: string,
    kind: CobaltBannerKind,
    hideSuffix = false,
    hideContactUs = false
  ): Message {
    const messageInfo = new Message();
    messageInfo.name = message;
    messageInfo.message = message;
    messageInfo.kind = kind;
    messageInfo.isVisible = true;
    messageInfo.hideSuffix = hideSuffix;
    messageInfo.hideContactUs = hideContactUs;
    return messageInfo;
  }

  public static empty(): Message {
    return new Message();
  }
}
